<!-- ng-content below adds the cdkDragHandle for a procedure (as that must be placed in the same template as the cdkDrag ) -->
<ng-content *ngIf="!editMode"></ng-content>

<!-- ROOT ACTIONS START -->
<ng-container *ngIf="procedure?.type !== 'conditional'; else procedureConditional">
	<div 
		cdkDropList 
		[attr.handlername]="handlerName"
		#ActionsContainer="cdkDropList"
		class="actions-container"
		[cdkDropListData]="procedure.actions"
		[cdkDropListConnectedTo]="actionDropsites" 
		(cdkDropListDropped)="drop($event)"
		(cdkDropListEntered)="entered($event)"
		(cdkDropListExited)="exited($event)">
		<action 
			*ngFor="let action of procedure.actions; let i = index; trackBy:actionTrackBy.bind(this)"
			cdkDrag
			[action]="action"
			[stateTrackingUid]="stateTrackingUid + '_a' + action.id"
			(delete)="removeAction($event)"
			(duplicate)="onDuplicateAction($event)"
			(actionChanged)="actionChanged($event)"
			></action>
	</div>
</ng-container>
<!-- ROOT ACTIONS END -->


<!-- CONDITIONAL PROCEDURE START -->
<ng-template #procedureConditional>
	<div class="conditional-procedure-wrapper" [class.expression-invalid]="expressionInvalid">
		<div class="condition" [ngClass]="{'condition-editmode': editMode}"
			(clickOutside)="toggleEditMode(false)" [clickOutsideActive]="editMode" [clickOutsideExcludeQueries]="['bb-modal']"
		>
			<div class="expression-rows" *ngIf="!editMode">
				<div class="expression-row" *ngIf="!expressionRows?.length" (click)="toggleEditMode(true);$event.stopPropagation()">
					<div></div>
					<div class="uppercase with-pointer">
						{{ 'EDIT_CONDITIONS' | translate }}
					</div>
				</div>
				<div class="expression-row" *ngIf="expressionInvalid" (click)="toggleEditMode(true);$event.stopPropagation()">
					<div class="ite-title"> </div>
					<div class="invalid-text">
						{{ 'INVALID_EXPRESSION' | translate }}
					</div>
				</div>
				<div class="expression-row" *ngFor="let expressionRow of expressionRows; trackBy:expressionTrackBy">
					<div class="ite-title">{{ expressionRow.o }}</div>
					<div> 
						<div 
							*ngIf="expressionRow.condition"
							(click)="toggleEditMode(true);$event.stopPropagation()"
							class="condition-type">
							<span class="ite-p1">{{ expressionRow.p1 }}</span>
							&nbsp;{{ expressionRow.condition.entityType }} 
							<span class="condition-rule">
								{{ getLRValue(expressionRow.condition.rule.lvalue) }} <i *ngIf="hasDataSource( expressionRow.condition.rule.lvalue )" class="fa fa-plug"></i> 
								<span class="condition-operator">{{ expressionRow.condition.rule.operator | valueToLabel : interactivityEditorService.operatorList }}</span> 
								{{ getLRValue(expressionRow.condition.rule.rvalue) }} <i *ngIf="hasDataSource( expressionRow.condition.rule.rvalue )" class="fa fa-plug"></i> 
							</span>
							<span class="ite-p2">{{ expressionRow.p2 }}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="edit-condition" *ngIf="editMode">
				<condition
					[expressionInvalid]="expressionInvalid"
					[condition]="procedure.condition"
					(expressionValueChange)="expressionValueChange($event)"
					(removeRequest)="deleteProcedure()"
					(conditionChanged)="conditionChanged($event)">
				</condition>
			</div>
		</div>
		<div class="actions conditional-block">
			<div class="ite-title">THEN</div>
			<div 
				cdkDropList 
				[attr.handlername]="handlerName"
				#ActionsContainer="cdkDropList"
				class="actions-container"
				[cdkDropListData]="procedure.actions"
				[cdkDropListConnectedTo]="actionDropsites" 
				(cdkDropListDropped)="drop($event)"
				(cdkDropListEntered)="entered($event)"
				(cdkDropListExited)="exited($event)">
				<action 
					*ngFor="let action of procedure.actions; let i = index; trackBy:actionTrackBy.bind(this)"
					cdkDrag
					[action]="action"
					[stateTrackingUid]="stateTrackingUid + '_a' + i"
					[theme]="'ite-theme'"
					(delete)="removeAction($event)"
					(duplicate)="onDuplicateAction($event)"
					(actionChanged)="actionChanged($event)"
					></action>
				<add-procedure (onChange)="actionAdded($event)" [actions]="procedure.actions" [theme]="'grey-theme'"></add-procedure>
			</div>
		</div>
		<div class="else-actions conditional-block">
			<div class="ite-title">ELSE</div>
			<div 
				cdkDropList 
				[attr.handlername]="handlerName"
				#ElseActionsContainer="cdkDropList"
				class="actions-container" 
				[cdkDropListData]="procedure.else_actions"
				[cdkDropListConnectedTo]="actionDropsites" 
				(cdkDropListDropped)="drop($event)"
				(cdkDropListEntered)="entered($event)"
				(cdkDropListExited)="exited($event)">
				<action 
					*ngFor="let action of procedure.else_actions; let i = index; trackBy:elseActionTrackBy.bind(this)"
					cdkDrag
					[action]="action"
					[stateTrackingUid]="stateTrackingUid + '_ea' + i"
					[theme]="'ite-theme'"
					(delete)="removeElseAction($event)"
					(duplicate)="onDuplicateAction($event)"
					(actionChanged)="actionChanged($event)">
				</action>
				<add-procedure (onChange)="actionAdded($event)" [actions]="procedure.else_actions" [theme]="'grey-theme'"></add-procedure>
			</div>
		</div>
	</div>
</ng-template>
<!-- CONDITIONAL PROCEDURE END -->
